import React, { useState, useEffect } from 'react';
import { Avatar, Typography, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { EditDeleteDialog } from '../shared/EditDeleteDialog.jsx';
import { formatApiDate } from '../../utils/_helpers.js';

// prettier-ignore
export const WBSUserDetails = ({ userDetails, userIndex, costCenterDescription, handleDeleteApprover,handleEditApprover, context }) => {

	const [color, setColor] = useState("");
	const [open, setOpen] = useState(false);
	const [dialogType, setDialogType] = useState("");

	useEffect(() => {
		setColor(randomColor())
	}, [])

	const handleClickOpenDialog = (type) => {
		setDialogType(type)
		setOpen(true);
	};

	const handleCloseDialog = () => {
		setOpen(false);
	};

	const randomColor = () => {
		const hex = Math.floor(Math.random() * 0xFFFFFF);
		const color = "#" + hex.toString(16);
		return color;
	};

	const getNameAndDelegation = (userDetails) => {
		return (
            `${userDetails.Uname}` +
            (userDetails.SubActFlag === 'X'
                ? ` (${formatApiDate(userDetails.SubStartDate)}-${formatApiDate(userDetails.SubEndDate)})`
                : '') +
            `${userDetails.Comment ? ` - ${userDetails.Comment}` : ''}`
        );
	};

	return (
		<div className={"flex-row-container"}>
			<div key={userIndex} className={'user-list'}>
				<Avatar sx={{ backgroundColor: color, marginRight: '1rem' }}>{userDetails.Uname !== "" ? userDetails.Uname.match(/\b(\w)/g).join('').toUpperCase() : ""}</Avatar>
				<div className={'user-name'}>{getNameAndDelegation(userDetails)}</div>
			</div>
			<div className={"flex-row-container"} style={{ marginRight: '2vw' }}>
				<Typography variant='body1' noWrap={true} sx={{ color: 'rgb(102, 110, 114)' }}>Order Cat. {userDetails.OrderCategory}</Typography>
				<Button
					color="primary"
					variant='contained'
					aria-label="edit"
					component="div"
					size='small'
					disabled={localStorage.getItem('edit') !== 'true'}
					sx={{
						borderRadius: '20px',
						padding: '0px 15px',
						margin: '0vw 1vw',
						textTransform: 'none',
					}}
					onClick={() => handleClickOpenDialog('edit')}
				>
					<EditIcon fontSize='small' />
					<Typography variant='body2'>Change</Typography>
				</Button>
				<Button
					color="secondary"
					variant='outlined'
					aria-label="delete"
					component="div"
					size='small'
					disabled={localStorage.getItem('edit') !== 'true'}
					sx={{
						borderRadius: '20px',
						padding: '0px 15px',
						textTransform: 'none',
					}}
					onClick={() => handleClickOpenDialog('delete')}
				>
					<DeleteIcon fontSize='small' />
					<Typography variant='body2'>Delete</Typography>
				</Button>
			</div>
			{open &&
				<EditDeleteDialog
					open={open}
					title={'WBS'}
					dialogType={dialogType}
					costCenterDescription={costCenterDescription}
					userDetails={userDetails}
					userIndex={userIndex}
					handleCloseDialog={handleCloseDialog}
					handleDeleteApprover={handleDeleteApprover}
					handleEditApprover={handleEditApprover}
					context={context}
					avatarColor={color}
				/>
			}
		</div>
	);
}
